(() => {
 if (customElements.get('dunya-accent-section')) return;
 class AccentSection extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController(); const signal = this.abort.signal;
   const track = this.querySelector('[data-track]');
   const prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
   const update = () => { if (!track) return; const max = track.scrollWidth - track.clientWidth; prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max - 2; };
   const size = () => { this.style.setProperty('--aw-viewport', document.documentElement.clientWidth + 'px'); update(); };
   size(); window.addEventListener('resize', size, {signal});
   if (track && prev && next) {
    this.querySelector('.aw__controls').hidden = false;
    const move = direction => { const card = track.querySelector('.aw__item'); if (!card) return; const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0); track.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); };
    prev.addEventListener('click', () => move(-1), {signal}); next.addEventListener('click', () => move(1), {signal});
    track.addEventListener('scroll',update,{signal,passive:true});
    track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},{signal});
    this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.aw__item');if(card&&track.contains(card))track.scrollTo({left:card.offsetLeft-track.firstElementChild.offsetLeft,behavior:'auto'});},{signal});
    this.observer = new ResizeObserver(update);this.observer.observe(track);update();
   }
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();}
 }
 customElements.define('dunya-accent-section',AccentSection);
})();

/* Reuse the existing Custom FlexMarble Apps Script payload contract. */
(() => {
 if(customElements.get('dunya-accent-upload')) return;
 class AccentUpload extends HTMLElement {
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();const signal=this.abort.signal;
   this.files=[];this.busy=false;
   this.form=this.querySelector('form');this.input=this.querySelector('[data-files]');
   this.status=this.querySelector('[data-upload-status]');this.list=this.querySelector('[data-file-list]');
   if(!this.form||!this.input)return;
   this.querySelector('[data-upload-area]').hidden=false;
   this.input.addEventListener('change',()=>{
    const errors=[];
    for(const file of this.input.files){
     if(!/\.(jpe?g|png|webp|pdf)$/i.test(file.name)){errors.push(file.name+': unsupported file type.');continue;}
     if(file.size===0||file.size>10*1024*1024){errors.push(file.name+': file must be nonempty and no larger than 10 MB.');continue;}
     if(this.files.some(f=>f.name===file.name&&f.size===file.size&&f.lastModified===file.lastModified))continue;
     if(this.files.length>=5||this.files.reduce((n,f)=>n+f.size,0)+file.size>20*1024*1024){errors.push('Maximum 5 files and 20 MB total.');continue;}
     this.files.push(file);
    }
    this.input.value='';this.status.textContent=errors.join(' ');this.render();
   },{signal});
   this.form.addEventListener('submit',e=>this.submit(e),{signal});
  }
  render(){
   this.list.replaceChildren();
   this.files.forEach((file,i)=>{
    const li=document.createElement('li'),label=document.createElement('span'),button=document.createElement('button');
    label.textContent=file.name+' ('+(file.size/1048576).toFixed(1)+' MB)';
    button.type='button';button.textContent='Remove';button.setAttribute('aria-label','Remove '+file.name);button.disabled=this.busy;
    button.addEventListener('click',()=>{if(!this.busy){this.files.splice(i,1);this.render();}});
    li.append(label,button);this.list.append(li);
   });
  }
  encode(file){return new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve({name:file.name,mimeType:file.type||'application/octet-stream',base64:String(reader.result).split(',')[1]});reader.onerror=()=>reject(new Error('Could not read '+file.name));reader.onabort=()=>reject(new Error('File reading cancelled'));reader.readAsDataURL(file);});}
  async submit(event){
   event.preventDefault();if(this.busy||!this.form.reportValidity())return;
   let url;try{url=new URL(this.dataset.endpoint);if(url.protocol!=='https:'||url.hostname!=='script.google.com'||!/^\/macros\/s\/[^/]+\/exec$/.test(url.pathname))throw new Error();}catch{this.status.textContent='The upload service is not configured correctly. Please call 610.943.1777.';return;}
   const values=new FormData(this.form),get=name=>String(values.get('contact['+name+']')||'').trim();
   const button=this.form.querySelector('button[type="submit"]'),label=button.textContent;
   this.busy=true;button.disabled=true;this.input.disabled=true;this.render();button.textContent='Sending…';this.status.textContent='Sending your request and files. Please keep this page open.';
   try{
    const designFiles=[];for(const file of this.files)designFiles.push(await this.encode(file));
    const description=['ACCENT WALL ESTIMATE','Project: '+get('body'),'Location: '+get('Location'),'Approximate measurements: '+get('Measurements'),'Budget: '+get('Budget'),'Photo / inspiration links: '+get('Photo links')].join('\n\n');
    const payload={fullName:get('name'),companyName:'',phone:get('phone'),email:get('email'),projectCity:get('Location'),customerType:get('Customer type'),application:'Feature Wall',projectCategory:get('Project category'),width:'',height:'',totalSqFt:'',finish:'Other',logoIntegration:'No',designDescription:description,timeline:get('Timeline'),logoFiles:[],designFiles,requestType:'Accent wall estimate',sourcePage:window.location.href};
    // Legacy service uses an opaque response. Do not claim verified delivery.
    await fetch(url.href,{method:'POST',mode:'no-cors',credentials:'omit',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify(payload)});
    this.status.textContent='Your request has been sent for processing. Delivery cannot be confirmed on this page. Please call 610.943.1777 if you need confirmation.';
    button.textContent='Request sent';
   }catch(error){
    this.status.textContent='We could not confirm that your request was sent. Your details and selected files are still here. Please try again or call 610.943.1777.';
    this.busy=false;button.disabled=false;this.input.disabled=false;button.textContent=label;this.render();
   }
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;}
 }
 customElements.define('dunya-accent-upload',AccentUpload);
})();
